(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalogue-tag-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target.closest?.('.catalogue-tag-filters__option');
    if (!link) return;
    const destination = new URL(link.href, location.href);
    destination.search = location.search;
    destination.searchParams.delete('page');
    destination.searchParams.delete('section_id');
    destination.searchParams.delete('sections');
    link.href = destination.href;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(destination.href);
  }, true);
  } catch(e) { console.error(e); }
})();

})();
